import Icon from 'veui/components/Icon'
import { IconBook } from 'dls-icons-vue'

Icon.register('book', IconBook)
